import Color from "colorjs.io";
import { hasMinimumContrast } from "@/lib/utils";
import { getBrandThemeFromColors } from "@/utils/branding/genieBrandTheme";
import type { GenieBranding } from "@/types/ui/branding";

/** Preserve the Genie's hues while keeping white button text readable at both ends. */
const readableButtonColor = (value: string): string => {
  try {
    const color = new Color(value);
    for (let step = 0; step <= 10; step += 1) {
      const candidate = color.mix("black", step / 10, { space: "srgb" }).toString({ format: "hex" });
      if (hasMinimumContrast("#FFFFFF", candidate)) return candidate;
    }
  } catch {
    // Invalid saved colors should never make the action unreadable.
  }
  return "#222B45";
};

export const getEmailWidgetButtonBackground = (branding: GenieBranding): string => {
  const theme = getBrandThemeFromColors(branding);
  const button = branding.embedStyle?.ctaButton;
  const start = readableButtonColor(button?.color || theme.primary);
  const end = readableButtonColor(button?.color2 || button?.color || (theme.gradientOn ? theme.secondary : theme.primary));
  return `linear-gradient(90deg, ${start}, ${end})`;
};
